/**
 * CSV アップロードの入口拒否上限 (bytes)。20 MB。
 *
 * spec `docs/specs/admin/data/uploads/common.md` 非機能要件「ファイルサイズ上限 20 MB」
 * (行数・削除件数の上限は設けない。2026-09-25 PdM 決定) を全データ種別に共通で当てる。
 * サーバー側の上限 (raw CSV を受ける Check / Import RPC の protovalidate `max_len`。
 * ブロック入札・時間前入札は上限値を含む文言を返すため usecase で判定) と同値で、
 * csvUpload.test.ts が同値を assert する。
 */
export const MAX_CSV_FILE_SIZE_BYTES = 20_971_520
